import Flickity from 'flickity-imagesloaded'

export const settings = {
  selector: '.js-contact-person-bar',
  carouselEl: '.js-contact-persons-carousel',
  showBelow: '.c-property-contact-persons__style-compact'
}

/**
 * Function initializes all elements in page.
 */
export default function initAll() {
  let elements = document.querySelectorAll( settings.selector )
  Array.from( elements ).forEach(( element ) => {
    init( element )
  })
}

/**
 * Function initializes all elements in page.
 */
function init( element ) {
  window.addEventListener( 'scroll', () => { stickyNavigation( element ) })
  stickyNavigation( element )
}

/**
 * Sticky Navigation.
 *
 * @param {DOMNode} element
 */
function stickyNavigation( element ) {
  const belowElement = document.querySelector( settings.showBelow )
  const carouselEl = element.querySelector( settings.carouselEl )

  var flick = new Flickity( carouselEl )
  flick.resize()

  if ( window.scrollY >= belowElement.offsetTop ) {
    document.body.classList.add( 'fixed-property-nav' )
  } else {
    document.body.classList.remove( 'fixed-property-nav' )
  }
}
